import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";


    export class Feather extends Phaser.Group {

        public sprite: Phaser.Sprite;

        constructor(game: Phaser.Game) {

            super(game, null, "feather");

            this.sprite = new Phaser.Sprite(this.game, 0, 0, "texture_atlas_1", "feather.png");
            this.sprite.anchor.set(.5);
            this.sprite.scale.set(.3);
            this.add(this.sprite);

            this.game.physics.enable(this.sprite, Phaser.Physics.ARCADE);

            this.game.add.tween(this.sprite)
                .to({y: [-10, 0]}, 1000, Phaser.Easing.Linear.None, true, 0, -1);

            this.disable();
            this.startDelayFeather();
        }

        public disable(): void {

            this.visible = false;
            this.sprite.body.enable = false;
        }

        public enable(): void {

            this.visible = true;
            this.alpha = 0;
            this.game.add.tween(this)
                .to({alpha: 1}, 250, Phaser.Easing.Linear.None, true);

            let x = GameConstants.GAME_WIDTH / 2 + GameVars.randomDataGenerator.integerInRange(-250, 250);
            let y = GameConstants.GAME_HEIGHT / 2 + GameVars.randomDataGenerator.integerInRange(-150, 150);

            this.position.set(x, y);

            this.sprite.body.enable = true;
            this.sprite.body.offset.y = -26;
            this.sprite.body.height = this.sprite.height + 24;
        }

        public startDelayFeather(): void {

            let time = GameVars.randomDataGenerator.integerInRange(1, 10);

            this.game.time.events.add(time * Phaser.Timer.SECOND, function(): void {
                this.enable();
            }, this);
        }
    }
